import {
  FlexColumn, Flex, SelectInput, SecondaryButton, Button,
} from '@equifinance/shared';
import { useState } from 'react';
import styled from 'styled-components';
import { Stage, useTasksContext } from '../../../contexts/tasks';

const ChangeStageModalContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[8]};
`}`;

const ButtonContainer = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[2]};
  justify-content: end;
`}`;

export default function ChangeStageModal({ close, taskIndex }: { close: () => void, taskIndex: number }) {
  const [stage, setStage] = useState<keyof typeof Stage | ''>('');
  const { updateTasks } = useTasksContext();

  const onConfirm = () => {
    updateTasks(`tasks[${taskIndex}].stage`, stage);
    close();
  };

  const options = Object.keys(Stage)?.reduce((acc, current) => ({ ...acc, [current]: current }), {});

  return (
    <ChangeStageModalContainer>
      <SelectInput
        id="task-new-stage"
        placeholder="Select"
        label="Before"
        value={stage}
        onChange={(value: any) => setStage(value)}
        options={options}
        required
      />
      <ButtonContainer>
        <SecondaryButton small onClick={close}>Cancel</SecondaryButton>
        <Button disabled={!stage} small onClick={onConfirm}>Confirm</Button>
      </ButtonContainer>
    </ChangeStageModalContainer>
  );
}
